import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Button,
  Container,
  Paper,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextareaAutosize,
  Stack,
  Divider,
  Grid,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  InputAdornment,
} from '@mui/material';
import AppTheme from '../../../../shared-theme/AppTheme';
import { CssBaseline } from '@mui/material';
import SideMenu from '../../../../components/SideMenu';
import Header from '../../../../components/Header';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Selector from '../../../../components/Selector';
import { DatePicker } from '@mui/x-date-pickers';
import { StyledCellHeader } from '../../../../components/StyledCellHeader';
import CrearBancoDialog from '../../../configuracion/bancos/crearbancodialog';
import CrearMonedaDialog from '../../../configuracion/monedas/crearmonedadialog';
import AutocompleteWithAdd from '../../../../components/AutocompleteWithAdd';
import { fetchBancos, fetchMonedas, fetchProveedores } from '../../../../utils/generalsFetch';



export default function AgregarPago() {
  const navigate = useNavigate();
  // Estados de ejemplo, puedes integrar con tu lógica/props
  const [amount, setAmount] = React.useState('');
  const [method, setMethod] = React.useState('');
  const [date, setDate] = React.useState('');
  const [account, setAccount] = React.useState('');
  const [notes, setNotes] = React.useState('');
  const [proveedor, setProveedor] = React.useState(null);
  const [openCrearBancoDialog, setOpenCrearBancoDialog] = React.useState(false);
  const [openCrearMonedaDialog, setOpenCrearMonedaDialog] = React.useState(false);
  const [bancos, setBancos] = React.useState([]);
  const [monedas, setMonedas] = React.useState([]);
  const [proveedores, setProveedores] = React.useState([]);
  const [moneda, setMoneda] = React.useState(null);
  const [facturasPendientes, setFacturasPendientes] = React.useState([]);

  useEffect(() => {
    fetchProveedores({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
        setProveedores(data);
      });
  
    fetchBancos({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setBancos(data);
    });
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setMonedas(data);
    });
  }, []);

  useEffect(() => {
    if(proveedor && moneda) {
      fetchFacturasPendientes();
    }
  }, [proveedor, moneda]);

  async function fetchFacturasPendientes() {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/facturas-compra-pendientes/${localStorage.getItem('idcompany')}/${proveedor.value}/${moneda.value}`);
    const data = await response.json();
    setFacturasPendientes(data);
  }

  const handleAddMoneda = () => {
    fetchMonedas({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setMonedas(data);
    });
    setOpenCrearMonedaDialog(false);
  }

  const handleAddBanco = () => {
    fetchBancos({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setBancos(data);
    });
    setOpenCrearBancoDialog(false);
  }

  const handleChangeMontoPagar = (e, id) => {
    const montoPagar = e.target.value;
    const factura = facturasPendientes.find(factura => factura.id === id);
    if(factura) {
      factura.monto_a_pagar = montoPagar;
      setFacturasPendientes([...facturasPendientes]);
    }
  }

  const handleGuardar = async () => {

    const nuevasFacturas = facturasPendientes.map(factura => ({
      idfactura: factura.id,
      monto_a_pagar: factura.monto_a_pagar,
      monto_pagado: parseFloat(factura.monto_pagado) + parseFloat(factura.monto_a_pagar),
      estado: parseFloat(factura.monto_total) - (parseFloat(factura.monto_pagado)+parseFloat(factura.monto_a_pagar)) > 0 ? "Pendiente" : "Pagado",
    }));

    const data = {
      idcompany: localStorage.getItem('idcompany'),
      creado_por: localStorage.getItem('id'),
      idproveedor: proveedor.value,
      idmoneda: moneda.value,
      idbanco: account.value,
      fecha_pago: date,
      metodo_pago: method,
      notas: notes,
      nuevasFacturas: nuevasFacturas,
    }

    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pagos-facturas-compra`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
      body: JSON.stringify(data),
    });
    const dataResponse = await response.json();
    if(dataResponse.msg === "Pago registrado") {
      navigate(-1);
    }
  }

  return (
    <AppTheme themeComponents={{}}>
      <CssBaseline enableColorScheme />
      <CrearBancoDialog open={openCrearBancoDialog} onClose={() => handleAddBanco()} />
      <CrearMonedaDialog open={openCrearMonedaDialog} onClose={() => handleAddMoneda()} />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
            <Stack
                spacing={2}
                sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
                }}>

                <Header parent={"Logistica y Almacenes"} child={"Pagos"} />
                <Container maxWidth={"lg"} sx={{ px: { xs: 2, md: 10 }, py: 5, display: "flex", justifyContent: "center", flexDirection: "column", backgroundColor: "transparent"}}>
                    <Box dividers display={"flex"} justifyContent={"flex-start"} >
                        <Button variant="outlined" startIcon={<ArrowBack/>} onClick={()=>{navigate(-1)}}>Atras</Button>
                        <Box display={"flex"} flexDirection={"column"} gap={2} ml={5}>
                            <Typography variant="h4" fontWeight={700} textAlign={"left"}>Agregar Pago</Typography>
                            <Typography variant="body1" color="text.secondary" textAlign={"left"} sx={{mt:-1}}>Agregar un pago a una factura de proveedor</Typography>
                        </Box>
                    </Box>
                    <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5}>
                        <Grid container spacing={2}>
                            <Grid item size={12}>
                                <Typography variant="h6" fontWeight={700} textAlign={"left"}>Informacion General del Pago</Typography>
                            </Grid>
                            <Grid item size={4}>
                                <Autocomplete
                                    options={proveedores}
                                    getOptionLabel={(option) => option.label}    
                                    renderInput={(params) => <TextField {...params} placeholder="Proveedor" fullWidth/>}
                                    onChange={(e, val) => setProveedor(val)}
                                />
                            </Grid>
                            <Grid item size={4}>
                                <AutocompleteWithAdd
                                    options={bancos}
                                    label="Cuenta Bancaria"
                                    value={account}
                                    onChange={(val) => setAccount(val)}
                                    onAdd={() => setOpenCrearBancoDialog(true)}
                                />
                            </Grid>
                            <Grid item size={4}>
                                <TextField placeholder='Fecha de Pago' type='date' value={date} onChange={(e) => setDate(e.target.value)} fullWidth helperText='Fecha de Pago'/>
                            </Grid>
                            <Grid item size={4}>
                                <Selector placeholder='Metodo de Pago' options={[{label:"Cheque", value:"Cheque"},{label:"Transferencia", value:"Transferencia"},{label:"Efectivo", value:"Efectivo"},{label:"Tarjeta", value:"Tarjeta"}]} value={method} onChange={(e) => setMethod(e.target.value)} />
                            </Grid>
                            <Grid item size={4}>
                                    <AutocompleteWithAdd label='Moneda' options={monedas} value={moneda} onChange={(val) => setMoneda(val)} onAdd={() => setOpenCrearMonedaDialog(true)} />
                            </Grid>
                            <Grid item size={8}>
                                <TextField placeholder='Notas' value={notes} onChange={(e) => setNotes(e.target.value)} fullWidth />
                            </Grid>
                        </Grid>
                        
                        
                    </Box>
                    {facturasPendientes.length > 0 && proveedor && moneda && (
                    <Box boxShadow={1} p={2} borderRadius={3} mt={2} padding={5}>
                        <Grid container spacing={2}>
                            <Grid item size={12}>
                                <Typography variant="h6" fontWeight={700} textAlign={"left"}>Facturas Pendientes</Typography>
                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>Asigne el monto a las facturas que desea pagar</Typography>
                            </Grid>
                            <Grid item size={12}>
                                <TableContainer component={Paper} sx={{ boxShadow: "none", minHeight: "300px" }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledCellHeader>Numero</StyledCellHeader>
                                                <StyledCellHeader>Vencimiento</StyledCellHeader>
                                                <StyledCellHeader>Total</StyledCellHeader>
                                                <StyledCellHeader>Pagado</StyledCellHeader>
                                                <StyledCellHeader>Por Pagar</StyledCellHeader>
                                                <StyledCellHeader>Monto a Pagar</StyledCellHeader>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {facturasPendientes.map((factura) => (
                                                <TableRow key={factura.id}>
                                                <TableCell>{factura.numero_factura}</TableCell>
                                                <TableCell>{factura.fecha_vencimiento}</TableCell>
                                                <TableCell>{factura.monto_total}</TableCell>
                                                <TableCell>{factura.monto_pagado}</TableCell>
                                                <TableCell>{parseFloat(factura.monto_total) - parseFloat(factura.monto_pagado).toFixed(2)}</TableCell>
                                                <TableCell>
                                                    <TextField placeholder='Monto a Pagar' type='number' inputProps={{startAdornment: <InputAdornment position="start">{moneda.symbol}</InputAdornment>}}  value={factura.monto_a_pagar} onChange={(e) => handleChangeMontoPagar(e, factura.id)} fullWidth/>
                                                </TableCell>
                                            </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                            <Grid item size={12}>
                                <Divider sx={{mb:2}}></Divider>
                                {facturasPendientes.reduce((acc, row) => acc + parseFloat(row.monto_a_pagar), 0) > 0 && (
                                <Box sx={{ display: "flex", justifyContent: "end", mt: 2, mr: 2 }}>
                                    <Typography variant="h6" color="text.secondary" textAlign={"left"} fontWeight={700}>Total: {facturasPendientes.reduce((acc, row) => acc + parseFloat(row.monto_a_pagar), 0)}</Typography>
                                </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                    )}
                    <Box sx={{ position: 'fixed', bottom: 0, left: 0, width: '100%', bgcolor: 'white', p: 2, borderTop: '1px solid #eee', textAlign: 'right', }}>
                        <Button variant="outlined"  sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={() => navigate(-1)}>Cancelar</Button>
                        <Button variant="contained" color="primarybutton" sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={() => handleGuardar()}>Guardar</Button>
                    </Box>

                </Container>
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
}
